import d3 = require("d3");
import * as React from "react";
import {GranularityType} from "../../../components/toolsbar/Toolbar";
import {PercentageCircle} from "../../../components/charts/PercentageCircle";
import {AppTranslations} from "../../../components/Utils/translations/AppTranslations";
import {SwitchCard} from "../../../components/buttons/SwitchCard";
import {operativityColors} from "../../../index";

declare var AppTranslations: AppTranslations;

interface Props {
    className?: string;
    granularity: GranularityType;
    startDate: Date;
    endDate: Date;
    value: number;
    total: number;
    onDynamicToggle?: (isChecked: boolean) => void;
}

interface State {
    switchChecked: boolean;
}

export class Header extends React.Component<Props, State> {

    constructor(props) {
        super(props);
        this.state = {
            switchChecked: false,
        };
    }

    public render() {
        return (
            <div className={this.props.className}>
                <div
                    style={{
                        height: "100%",
                        position: "relative",
                    }}
                >
                    <HeaderTitle
                        granularity={this.props.granularity}
                        startDate={this.props.startDate}
                        endDate={this.props.endDate}
                    />
                    <div
                        style={{
                            float: "left",
                            position: "absolute",
                            bottom: 0,
                        }}
                    >
                        <SwitchCard
                            onChange={this.handleScaleModeChange}
                            checked={this.state.switchChecked}
                            label={AppTranslations.operativityPanel.scaleDynamically}
                            textColor={"black"}
                        />
                    </div>
                </div>
                <div>
                    <Percentage value={this.props.value} total={this.props.total}/>
                </div>
            </div>
        );
    }

    private handleScaleModeChange = (isChecked) =>
        this.setState({
            switchChecked: isChecked,
        }, () => {
            if (this.props.onDynamicToggle) {
                this.props.onDynamicToggle(this.state.switchChecked);
            }
        })
}

interface HeaderTitleProps {
    granularity: GranularityType;
    startDate: Date;
    endDate: Date;
}

const HeaderTitle: React.FC<HeaderTitleProps> = (props) => {
    return (
        <div
            style={{
                overflow: "hidden",
                height: "calc(100% - 32px)",
            }}
        >
            <h1 style={{marginBottom: 5}}>{titleFromGranularity(props.granularity)}</h1>
            <h3 style={{marginBottom: 25}}>
                {AppTranslations.operativityPanel.from} <span className={"bold black-text"}>
                    {
                        (window as any).getSalesXAxisTimeFormatter(
                            props.granularity === GranularityType.HOUR ? GranularityType.HOUR : GranularityType.DAY,
                            props.startDate,
                            0,
                            d3.timeFormatLocale((window as any)
                                .getVBXChartLocaleFormatter()).format,
                            true,
                        )
                    }
                </span> {AppTranslations.operativityPanel.to} <span className={"bold black-text"}>
                    {
                        (window as any).getSalesXAxisTimeFormatter(
                            props.granularity === GranularityType.HOUR ? GranularityType.HOUR : GranularityType.DAY,
                            props.endDate,
                            0,
                            d3.timeFormatLocale((window as any).getVBXChartLocaleFormatter()).format,
                            true,
                        )
                    }
                </span>
            </h3>
            <h3 style={{maxWidth: 700, height: "100%", overflow: "hidden"}}>
                {AppTranslations.operativityPanel.subTitle}
            </h3>
        </div>
    );
};

function titleFromGranularity(granularity: GranularityType) {
    switch (granularity) {
        case GranularityType.HOUR: {
            return AppTranslations.operativityPanel.hourlyTitle;
        }
        case GranularityType.DAY: {
            return AppTranslations.operativityPanel.dailyTitle;
        }
        case GranularityType.WEEK: {
            return AppTranslations.operativityPanel.weeklyTitle;
        }
        case GranularityType.MONTH: {
            return AppTranslations.operativityPanel.monthlyTitle;
        }
        case GranularityType.QUARTER: {
            return AppTranslations.operativityPanel.quarterlyTitle;
        }
        default: {
            return AppTranslations.operativityPanel.yearlyTitle;
        }
    }
}

interface PercentageProps {
    value: number;
    total: number;
}

const Percentage: React.FC<PercentageProps> = (props) => {
    return (
        <div
            style={{
                fontSize: "1em",
                textAlign: "center",
            }}
        >
            <PercentageCircle
                width={150}
                height={150}
                percentage={props.total > 0 ? props.value * 100 / props.total : 0}
                name={""}
                percentageColor={operativityColors.percentage}
                percentageColorOpacity={operativityColors.percentageOpacity}
                arcWidth={20}
            />
            <div style={{textAlign: "center", marginTop: 16, maxWidth: 200, fontSize: "15px"}}>
                {AppTranslations.operativityPanel.totalsCardTitle}
            </div>
        </div>
    );
};